// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3tph0","header":"ReportDetails_header__1zJh3","title":"ReportDetails_title__bG9Gt","left":"ReportDetails_left__3SqZC"};